/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Status of the terminal application.
 */
export const TerminalApplicationStatus = {
  Undefined: "undefined",
  Pending: "pending",
  Enabled: "enabled",
  Disabled: "disabled",
} as const;
/**
 * Status of the terminal application.
 */
export type TerminalApplicationStatus = ClosedEnum<
  typeof TerminalApplicationStatus
>;

/** @internal */
export const TerminalApplicationStatus$inboundSchema: z.ZodNativeEnum<
  typeof TerminalApplicationStatus
> = z.nativeEnum(TerminalApplicationStatus);
/** @internal */
export const TerminalApplicationStatus$outboundSchema: z.ZodNativeEnum<
  typeof TerminalApplicationStatus
> = TerminalApplicationStatus$inboundSchema;
